<template>
  <v-speed-dial
    v-model="fab"
    :direction="direction"
    :hover="hover"
    :transition="transition"
    :open-on-hover="true"
    bottom
    right
    fixed >
    <v-btn
      slot="activator"
      v-model="fab"
      class="warning"
      dark
      small
      fab
      hover >
      <v-icon>fas fa-cog</v-icon>
      <!--<v-icon>close</v-icon>-->
    </v-btn>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="green"
        @click.stop="createMatch" >
        <v-icon>add</v-icon>
      </v-btn>
      <span>{{ $t('menu.addMatch') }}</span>
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="green"
        @click.stop="createMatchMultiple" >
        <v-icon>playlist_add</v-icon>
      </v-btn>
      <span>{{ $t('menu.addMatchMultiple') }}</span>
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="green"
        @click.stop="adminUsers"
      >
        <v-icon>group</v-icon>
      </v-btn>
      <span>{{ $t('menu.clubUsers') }}</span>
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="green"
        @click.stop="editClub"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <span>{{ $t('menu.editClub') }}</span>
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="green"
        @click.stop="editSponsors"
      >
        <v-icon>folder_shared</v-icon>
      </v-btn>
      <span>{{ $t('menu.editSponsors') }}</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
// const debug = require('debug')('OD::AdminButton')

export default {
  name: 'AdminButton',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      direction: 'top',
      fab: false,
      transition: 'slide-y-reverse-transition',
      menuOpenClub: false,
      hover: true,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    editClub() {
      this.$emit('editClub')
    },
    editSponsors() {
      this.$emit('editSponsors')
    },
    createMatch() {
      this.$emit('createMatch')
    },
    adminUsers() {
      this.$emit('adminUsers')
    },
    createMatchMultiple() {
      this.$emit('createMatchMultiple')
    },
  },
}
</script>

<style lang="scss">
</style>
